import React from 'react';
import { Box, Paper, fade } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';

const useStyles = makeStyles((theme) => ({
  filter: {
    border: `1px solid ${fade(theme.palette.primary.main, 0.3)}`,
    backgroundColor: fade(theme.palette.primary.main, 0.14),
  },
  subFilter: {
    border: `1px solid ${fade(theme.palette.primary.main, 0.3)}`,
    backgroundColor: 'rgba(255, 255, 255, 0.5)',
  },
}));

export default function PaperAster({ type, ...props }) {
  const classes = useStyles();
  return (
    <Box
      component={Paper}
      square
      variant={'outlined'}
      className={clsx({
        [classes[type]]: true,
      })}
      p={2}
      {...props}
    ></Box>
  );
}
